class AsyncNextStep {
    constructor() {
        this._init()
    }

    _init() {
        document.querySelectorAll('[data-async-next-step]').forEach((el) => {
            new AsyncNextStepItem(el)
        })
    }
}

class AsyncNextStepItem {
    constructor(el) {
        this.el = el
        this.url = el.dataset.asyncNextStep

        this._init()
    }

    _init() {
        this.update()
    }

    update() {
        // debugger;
        this.el.innerHTML = 'Loading...'
        fetch(this.url).then((response) => {
            return response.text();
        }).then((html) => {
            if (html) {
                this.el.innerHTML = html;
            }
        }).catch((error) => {
            console.error(error);
        });

    }
}


export default AsyncNextStep